<template>
  <div class="app-layout__wrap">
    <el-menu
      data-test="navbar"
      class="app-layout__sidenav"
      :collapse="true">

      <!-- <el-menu-item
        v-for="item in menuItems"
        @click="pushRoute({ name: item.routeName })"
        :index="item.key"
        :key="item.key"
        :class="{ 'is-active': isRouteActive(item.routeName) }"
        :data-test="item.dataTest">
        <i :class="item.iconClass" v-if="item.subMenu.length === 0"></i>
        <span v-if="item.subMenu.length === 0">{{ $t(item.i18n) }}</span>

        <el-submenu :index="item.key" v-if="item.subMenu.length > 0">
          <template slot="title">
            <i :class="item.iconClass"></i>
            <span>{{ $t(item.i18n) }}</span>
          </template>
          <el-menu-item
            v-for="subItem in item.subMenu"
            :key="subItem.key"
            :index="subItem.key">{{ subItem.routeName }}</el-menu-item>
        </el-submenu>
      </el-menu-item> -->
      <!-- <MenuItem v-for="item in menuItems"
      :key="item.key"
      :item="item" /> -->
      <span  v-for="item in menuItems"
      :key="item.key"
      :item="item">
          <el-menu-item
            @click="pushRoute({ name: item.routeName })"
            :index="item.key"
            :class="{ 'is-active': isRouteActive(item.routeName) }"
            :data-test="item.dataTest"
            v-if="item.subMenu.length === 0">
            <div :data-v-step="`menu-${item.routeName}`">
              <i :class="item.iconClass" ></i>
              <span class="name-menu">{{ $t(item.i18n) }}</span>
            </div>
          </el-menu-item>

          <el-submenu :index="item.key" v-if="item.subMenu.length > 0">
            <template slot="title">
              <div :data-v-step="`menu-${item.routeName}`">
              <i :class="item.iconClass"></i>
              <span :class="['name-menu', `${item.routeName}`]">{{ $t(item.i18n) }}</span>
            </div>
            </template>
            <el-menu-item
              v-for="subItem in item.subMenu"
              :key="subItem.key"
              @click="pushRoute({ name: subItem.routeName })"
              :index="subItem.key">
              <i :class="subItem.iconClass" ></i>
              {{ $t(subItem.i18n) }}
            </el-menu-item>
          </el-submenu>
      </span>

      <span>
        <el-submenu index="99">
        <template slot="title">
          <i class="el-icon-user-solid"></i>
          <!-- <span slot="title">Navigateur Un</span> -->
          <span :class="['name-menu', 'profil']">Profil</span>
        </template>
        <el-menu-item-group>
          <span slot="title">Magasin</span>
          <el-menu-item index="1-1" class="profil-info-menu" :disabled="true">
            {{ shopInfos.shopId }} - {{ shopInfos.nameShop}}
          </el-menu-item>
          <el-menu-item index="1-2" class="profil-info-menu" :disabled="true">
            {{ shopInfos.mailShop}}
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="Utilisateur">
          <el-menu-item index="1-3" class="profil-info-menu" :disabled="true">
            {{ userName }}
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item
          index="1-4"
          @click="pushRoute({ name: 'Logout' })"
          style="border-top: 1px solid #dfe6e9;"
          data-test="navbar__logout-link">
          <i class="el-icon-switch-button" ></i>
          {{ $t('mainNav.logoutMenuItem') }}
        </el-menu-item>

      </el-submenu>
    </span>
    </el-menu>

    <div class="app-layout__view">
      <router-view></router-view>
    </div>
    <v-tour name="myTour1" :steps="steps" :options="myOptions" :callbacks="myCallbacks"></v-tour>
  </div>
</template>

<script>
// import MenuItem from '@/components/Menu/MenuItem.vue';
import services from 'services';

export default {
  components: {
    // MenuItem,
  },
  async mounted() {
    await this.$store.dispatch('auth/fetchCurrentUserProfile');
    await this.$store.dispatch('shopAuth/updateShop');

    const userInfo = this.$store.getters['auth/currentUserProfile'];
    this.userName = userInfo.displayName;
    this.shopInfos = this.$store.getters['shopAuth/shopInfos'];

    const isAuthenticated = await services.authService.isAuthenticatedFirebase();
    if (isAuthenticated === false) {
      this.$alert('Votre session a expiré. Veuillez vous reconnecter.', 'Session expiré', {
        confirmButtonText: 'OK',
        type: 'error',
        showClose: false,
        callback: () => {
          this.pushRoute({ name: 'Logout' });
        },
      });
    }
  },
  data() {
    return {
      userName: '',
      shopInfos: {
        shopId: '',
        mailManageurSecteur: '',
        mailShop: '',
        nameShop: '',
      },
      menuItems: [
        {
          i18n: 'mainNav.Inventory',
          routeName: 'Inventory',
          key: '2',
          iconClass: 'el-icon-s-order',
          dataTest: 'navbar__saisie-conso',
          subMenu: [
            {
              i18n: 'mainNav.saisieInventory',
              routeName: 'SaisieInventory',
              key: '6',
              iconClass: 'el-icon-edit-outline',
              dataTest: 'navbar__saisie-conso',
            },
            {
              i18n: 'mainNav.historyInventory',
              routeName: 'HistoryInventory',
              key: '7',
              iconClass: 'el-icon-time',
              dataTest: 'navbar__saisie-conso',
            },
          ],
        },
      ],
      myOptions: {
        useKeyboardNavigation: true,
        highlight: true,
        labels: {
          buttonSkip: 'Ignorer le guide',
          buttonPrevious: 'Précédent',
          buttonNext: 'Suivant',
          buttonStop: 'Terminer',
        },
      },
      myCallbacks: {
        onSkip: this.OnSkipCallback,
        onFinish: this.OnFinishCallback,
      },
      steps: [
        {
          // target: '[data-v-step="1"]', // We're using document.querySelector() under the hood
          // target: '.name-menu.Inventory', // We're using document.querySelector(
          // target: '.el-submenu:nth-child(2) .el-submenu__title',
          // target: '.div-menu-Inventory',
          target: '[data-v-step="menu-Inventory"]',
          content: 'Ce menu vous permettra de gérer votre inventaire (saisie et historique).',
        },
        {
          // target: '[data-v-step="1"]', // We're using document.querySelector() under the hood
          // target: '.el-submenu:first-child .el-submenu__title',
          target: '[data-v-step="menu-SaisieConso"]',
          content: 'Ce menu vous permettra de gérer votre suivi conso (saisie et historique).',
        },
        {
          target: '[data-v-step="prod-qty-av"]',
          content: 'Dans ce champ de texte, saisissez la quantité en zone avant du magasin.',
        },
        {
          target: '[data-v-step="prod-qty-ar"]',
          content: 'Dans ce champ de texte, saisissez la quantité en zone arrière du magasin.',
        },
        {
          target: '[data-v-step="total"]',
          content: 'Le total s\'actualisera automatiquement.',
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="btn-print"]',
          content: 'Vous avez la possibilité d\'imprimer le listing des produits.',
        },
        {
          target: '[data-v-step="menu-Logout"]',
          content: 'Cliquez ici pour vous déconnecter.',
        },
      ],
    };
  },
  methods: {
    isRouteActive(name) {
      return name === this.$route.name;
    },
    pushRoute(route) {
      if (route.name !== this.$route.name) {
        this.$router.push(route);
      }
    },
    open() {
      this.$confirm('Bienvenue sur l\'application inventaire et suivi conso. Voulez-vous suivre le guide ?', 'Guide utilisateur', {
        confirmButtonText: 'Oui',
        cancelButtonText: 'Ignorer le guide',
        type: 'info',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        // this.$message({
        //   type: 'success',
        //   message: 'Fichier supprimé',
        // });
        this.$tours.myTour1.start();
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Suppression annulée',
        // });
        this.$store.dispatch('auth/setUserGuide');
      });
    },
    OnSkipCallback() {
      this.$store.dispatch('auth/setUserGuide');
    },
    OnFinishCallback() {
      this.$store.dispatch('auth/setUserGuide');
    },
  },
};
</script>

<style lang="stylus" scoped>

$desktop-navbar-width = 210px;
$tablet-navbar-width = 60px;

@media (min-width: 768px){
  .app-layout__sidenav {
    width: $desktop-navbar-width;
  }

  .app-layout__view {
    left: $desktop-navbar-width;
  }
}

@media (max-width: 767px){
  .app-layout__sidenav {
    width: $tablet-navbar-width;
  }

  .app-layout__view {
    left: $tablet-navbar-width;
  }
  .name-menu, .el-icon-arrow-right:before{
    display: none;
  }
}

.app-layout__wrap {
  /* background: #edf1f8; */
  background: #fff;
  display: flex;
  min-height: 100vh;
}

.app-layout__sidenav {
  position: fixed;
  left: 0;
  top: 0; bottom: 0;
}

.app-layout__view {
  position: fixed;
  top: 0; bottom: 0;
  right: 0;
  display: flex;
  overflow-y: scroll;
}

.profil-info-menu {
  cursor: default;
  opacity: 1;
  font-style: italic;
  font-size: 12px;
}
</style>
